import { render } from "./IconReply.vue?vue&type=template&id=ea8a9680"
import script from "./IconReply.vue?vue&type=script&lang=js"
export * from "./IconReply.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__